import { AxiosInstance } from 'axios';
import { ShiftPatternsRepository } from '@/model/repository/shift/ShiftPatternsRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): ShiftPatternsRepository => ({
    index() {
      return Repository.get(`${resource}`);
    },
    show(id: string) {
      return Repository.get(`${resource}/${id}`);
    },
    create(payload) {
      const params = Object.assign(payload, { errorHandle: false });
      return Repository.post(`${resource}`, params);
    },
    update(id, payload) {
      const params = Object.assign(payload, { errorHandle: false });
      return Repository.put(`${resource}/${id}`, params);
    },
  });
